import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiProfileIconComponent } from './profile-icon.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, MatIconModule],
    declarations: [FiProfileIconComponent],
    exports: [FiProfileIconComponent],
})
export class FiProfileIconModule {}
